export default "__VITE_ASSET__48aa89f1__"